/** @format */

import React from "react";

export default () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.2 0H1.8C0.81 0 0 0.81 0 1.8V16.2C0 17.19 0.81 18 1.8 18H16.2C17.19 18 18 17.19 18 16.2V1.8C18 0.81 17.19 0 16.2 0ZM5.4 16.2H1.8V12.6H5.4V16.2ZM5.4 10.8H1.8V7.2H5.4V10.8ZM5.4 5.4H1.8V1.8H5.4V5.4ZM10.8 16.2H7.2V12.6H10.8V16.2ZM10.8 10.8H7.2V7.2H10.8V10.8ZM10.8 5.4H7.2V1.8H10.8V5.4ZM16.2 16.2H12.6V12.6H16.2V16.2ZM16.2 10.8H12.6V7.2H16.2V10.8ZM16.2 5.4H12.6V1.8H16.2V5.4Z" />
  </svg>
);
